export default {
    versionNumber: "1.1.3",
};
